import { render, staticRenderFns } from "./AssetClass.vue?vue&type=template&id=ef7450ce&"
import script from "./AssetClass.vue?vue&type=script&lang=js&"
export * from "./AssetClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports